var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, OnInit } from '@angular/core';
import { AgencyService } from '../common-theme/api/agency.service';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var TermsComponent = /** @class */ (function (_super) {
    __extends(TermsComponent, _super);
    function TermsComponent(injector, agencyService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.agencyService = agencyService;
        return _this;
    }
    TermsComponent.prototype.ngOnInit = function () {
        this.setTitle('Termeni și condiții - Dream Residence');
        this.setMetaDescription("Termenii \u0219i condi\u021Biile de utilizare a site-ului Dream Residence: date de identificare,\n      proprietate intelectual\u0103, prelucrarea datelor cu caracter personal \u0219i solu\u021Bionarea litigiilor.");
    };
    return TermsComponent;
}(SeoAwareBaseComponent));
export { TermsComponent };



// WEBPACK FOOTER //
// ./src/app/terms/terms.component.ts.pre-build-optimizer.js